import React, { useState, useEffect, useCallback } from 'react'
import {
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { healthDataTypeListPromise } from 'api/HealthDataType'

// Read-only. Every column here is a live contract, not editable data: a source name is a URL path
// segment (/provider/upload/:source), a type name is a key of the client's upload payload and of
// RawHealthDataFormatter, and the ids are hardcoded in the integrations. A row only means anything
// once the code that reads it ships, so new rows arrive with that release as a db/data patch.
//
// The list still earns its place: a missing row makes raw health data accumulate with no error
// anywhere, and this is where you look.
export default function HealthDataTypeList () {
  const [types, setTypes] = useState([])
  const [sources, setSources] = useState([])

  const load = useCallback(async () => {
    const data = await healthDataTypeListPromise() || {}
    setTypes(data.types || [])
    setSources(data.sources || [])
  }, [])

  useEffect(() => { load() }, [load])

  const sourceName = id => (sources.find(s => s.id === id) || {}).name || '-'

  return (
    <div className={'root'}>
      <div className={'content'}>
        <Card>
          <CardHeader
            title='Health data sources'
            subheader='Read-only. The name is a URL path segment, so renaming one breaks every client still calling the old path. New rows ship with the code that reads them.'
          />
          <CardContent>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sources.map(source => (
                  <TableRow key={source.id} hover>
                    <TableCell>{source.id}</TableCell>
                    <TableCell>{source.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        <br />

        <Card>
          <CardHeader
            title='Health data types'
            subheader='Read-only. The name is a key of the upload payload. A missing row makes raw rows accumulate with no error anywhere — check here first.'
          />
          <CardContent>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Source</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {types.map(type => (
                  <TableRow key={type.id} hover>
                    <TableCell>{type.id}</TableCell>
                    <TableCell>{type.name}</TableCell>
                    <TableCell>{type.dataSourceId} — {sourceName(type.dataSourceId)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
